import axiosInstance from "../../lib/axios";

export async function insertModuleRights(payload) {
  try {
  return  await axiosInstance.post("ModuleMst/InsertModuleMst", payload);
  } catch (error) {
    return error;
  }
}
export async function updateModuleRights(payload) {
    try {
    return  await axiosInstance.post("ModuleMst/UpdateModuleMst", payload);
    } catch (error) {
      return error;
    }
  }
  export async function retriveModuleRights(payload) {
    try {
      return await axiosInstance.post("ModuleMst/RetriveMstModule", payload);
    } catch (error) {
      return error;
    }
  }
 

  export async function moduleRightsDrp(payload) {
    try {
     return await axiosInstance.post("ModuleMst/GetmoduleMstdrp",payload);
    } catch (error) {
      return error;
    }
  }

